import request from '@/utils/request'
// 赛事中心接口
export function competitionList() {
	return request({
		url: '/oge-user-boot/api/competition/list',
		method: 'get'
	})
}

// 订阅
export function subscribeEmail(data) {
	return request({
		url: '/management/subscribe',
		method: 'post',
		data: data
	})
}
